import { INCREMENT_PENDING_REQUESTS, DECREMENT_PENDING_REQUESTS } from "../actions/types";

const initalState = {
    pendingRequests: 0
}

export default function(state = initalState, action){
    switch(action.type) {
        case INCREMENT_PENDING_REQUESTS:
            return {
                ...state,
                pendingRequests: state.pendingRequests + 1
            }
        case DECREMENT_PENDING_REQUESTS:
            return {
                ...state,
                pendingRequests: state.pendingRequests - 1 
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/SHARED/reducers/loading.reducer.js